import BaseNMComAdapter from "adapters/base.nmcom.adapter";
import BaseNMComCollection from "collections/base.nmcom.collection";

export default class FieldAdapter extends BaseNMComAdapter {
	static standardizeOptions(object, options = {}) {
		options['baseUrl'] = options['baseUrl'] || "<%=fieldApiBaseUrl%>";
		options['params'] = Object.assign({}, options['params'], (object || {}).params);
		if (object instanceof BaseNMComCollection) {
			options['params']['page[size]'] = object.getPageSize();
			options['params']['page[number]'] = object.getPageNumber();
		}
		return super.standardizeOptions(object, options)
	}

	static receiveResponse(response, object, options) {
		if (object instanceof BaseNMComCollection) {
			const headers = response.headers || {};
			const pageSize = parseInt(headers['nmx-page-size'] || 0);
			const pageNumber = parseInt(headers['nmx-page-number'] || 0);
			const resultCount = parseInt(headers['nmx-result-count'] || 0);

			object.setPageSize(pageSize)
				.setPageNumber(pageNumber)
				.setResultCount(resultCount)
		}
	}

	static getEnsembleByAgentNumber(agentNumber) {
		return super.promiseRPC(`getEnsembleByAgentNumber/${agentNumber}`,{});
	}
}
